// TODO: Add unit tests and flow type annotations
import { ScrollLock, MediaQuery, PubSub } from '../utils/'

const COMPONENT_CLASS = 'ps-main-nav'
const SELECTORS = {
  LEVEL_1_ITEM: 'js-main-nav-item-level-1'
}

const STATES = {
  ACTIVE: 'm-is-active',
  OPEN: 'm-is-open'
}

let $mainNav
let $level1Items
let $hamburgerMenu
let $activeTopLevelItem
let isNavOpen = false
let mediaQuery

/**
 * Initialize the script
 */
const init = () => {
    mediaQuery = MediaQuery.create({ maxWidth: 767 })

    $mainNav = document.querySelector(`.${COMPONENT_CLASS}`)
    // in case we have no header i.e confirmation page
    if ($mainNav == null) return

    $level1Items = [...document.querySelectorAll(`.${SELECTORS.LEVEL_1_ITEM}`)]
    $hamburgerMenu = document.querySelector('#hamburger')

    // Store a reference to the initial active item
    $activeTopLevelItem = $mainNav.querySelector(`[${STATES.ACTIVE}]`)

    addEventListeners()
}

/**
 * Function called when toggle custom event is published
 * @param {Object} data - object passed in from pubsub publish
 */
const respondToToggle = data => {

  // Check that the toggle element trigger was from the header search handle
  if (data.element.id == 'PsSearchBarHandle' && isNavOpen) {
    // TODO: reduce repitition
    closeMenus()
    resetActiveStates()
    ScrollLock.release()
  }
}

/**
 * Checks the if the browsing device width is within the defined breakpoint range
 */
const isMobile = () => mediaQuery.matches;

/**
 * Event delegation - TODO: move to global util
 * @param {any} e Event data
 */
const delegateEventMainNav = e => {
    const $target = e.target
    const isActiveTarget = $target.hasAttribute(STATES.ACTIVE)
    const isOpenTarget = $target.hasAttribute(STATES.OPEN)

    if ($target.classList.contains(SELECTORS.LEVEL_1_ITEM)) {
        toggleNavState($target, isActiveTarget, isOpenTarget)
    }
}

/**
 * Toggles the visible state of a given nav item
 * @param {any} $el
 * @param {any} isActive
 */
const toggleNavState = ($el, isActive, isOpen) => {
  removeStatesInCollection($level1Items, STATES.OPEN)

  if (isActive == false && isOpen == false) {
      removeStatesInCollection($level1Items, STATES.ACTIVE)
      $el.setAttribute(STATES.ACTIVE, '')
  }

  if (isOpen == false) {
    $el.setAttribute(STATES.OPEN, '')
    isNavOpen = true
  }

  PubSub.publish(`mainnav:${isNavOpen ? 'open' : 'closed'}`)

}

/**
 * Removes a given state from all items in a given collection
 * @param {any} $collection
 * @param {any} state
 */
const removeStatesInCollection = ($collection, state) => {
    $collection.forEach($el => $el.removeAttribute(state))
}

/**
 * Fires methods when user clicked on an element that is not a matched child of the main nav
 * @param {any} e
 */
const onExternalClick = e => {
    var regex = RegExp(COMPONENT_CLASS.replace('ps-', ''), 'gi')

    // check if the element clicked has our component name if the class lsi
  if (regex.test(e.target.className) == false && isNavOpen == true) {
        closeMenus()
        resetActiveStates()
        ScrollLock.release()
    }

}

/**
 * Close open menus
 */
const closeMenus = () => {
  isMobile()
    ? $mainNav.removeAttribute(STATES.ACTIVE, '')
    : removeStatesInCollection($level1Items, STATES.OPEN)

  isNavOpen = false
}

/**
 * Toggles the state of the entire menu tree on small devices
 */
const toggleMobileMenu = () => {
  const isOpen = $mainNav.hasAttribute(STATES.ACTIVE)

  $mainNav[isOpen ? 'removeAttribute' : 'setAttribute'](STATES.ACTIVE, '')

  isOpen ? ScrollLock.release() : ScrollLock.lock()

  isNavOpen = !isOpen
  PubSub.publish(`mainnav:${isNavOpen ? 'open' : 'closed'}`)
}

/**
 * Restores the original active state
 */
const resetActiveStates = () => {
    // If we're on a page not listed in the nav tree, an active item will not exist
    if ($activeTopLevelItem == null) return

    removeStatesInCollection($level1Items, STATES.ACTIVE)

    $level1Items.forEach($el => {
        if ($el.innerText == $activeTopLevelItem.innerText)
            $el.setAttribute(STATES.ACTIVE, '')
    })
}

const addEventListeners = () => {
  PubSub.subscribe('toggle:open', respondToToggle)

  $mainNav.addEventListener('click', delegateEventMainNav)
  $hamburgerMenu.addEventListener('click', toggleMobileMenu)
  window.addEventListener('click', onExternalClick)
  window.addEventListener('orientationchange', closeMenus)
}

const MainNav = { init }
export default MainNav



// WEBPACK FOOTER //
// ./js/core/MainNav.js